import ScrollAnimation from "react-animate-on-scroll";
import ExperienceInfo from "./ExperienceInfo";
import experiences from "../data/experiences";

const Experience = () => {

  return (
    <section id="experience">
      <ScrollAnimation animateOnce={true} animateIn="fadeInLeft" >
        <div className="header">
          <div className="headerText">
            <span>EXPERIENCE</span>
            <ScrollAnimation animateOnce={true} className="headerBar" delay={500} animateIn="fadeInLeft">
            </ScrollAnimation>
          </div>
        </div>
      </ScrollAnimation>
      {experiences.map(experience => (
        <ExperienceInfo key={experience.id} experience={experience} />
      ))}
    </section>
  )
}

export default Experience;
